export const efundingFaq = [
  {
    id: 1,
    title: "Apakah Itu Efunding?",
    description:
      "Efunding adalah platform digital berbasis website yang dikembangkan oleh PT Efunding Teknologi Keuangan, Efunding menghubungkan Anda dengan produk keuangan dari Lembaga Keuangan syariah yang telah bermitra dengan Efunding. Melalui teknologi canggih dan sistem yang user-friendly, memungkinkan calon pengguna untuk mengakses berbagai produk keuangan syariah secara daring dari mana saja tanpa terbatas jarak, tanpa perlu mengunjungi kantor cabang Lembaga Keuangan tertentu.",
  },
  {
    id: 2,
    title: "Siapakah PT Efunding Teknologi Keuangan?",
    description:
      "PT Efunding Teknologi Keuangan adalah perusahaan berbadan hukum resmi di Indonesia yang bergerak dibidang teknologi finansial (fintech) penyelenggara Inovasi Teknologi Sektor Keuangan (ITSK) yang termasuk dalam cluster Agregasi Informasi Produk dan Layanan Jasa Keuangan. Dalam menjalankan kegiatan muamalah-nya Efunding merujuk kepada prinsip syariah atau prinsip hukum ISLAM, sehingga termasuk dalam kategori fintech syariah.",
  },
  {
    id: 3,
    title: "Apa yang bisa saya dapatkan dari Efunding?",
    description:
      "kami memberikan informasi dan menyediakan layanan pengajuan produk perbankan syariah seperti: Tabungan syariah, Deposito Syariah dan Pembiayaan Syariah. Tentunya dalam hal ini kami juga berusaha bekerjasama dengan Lembaga Keuangan Syariah atau instansi terkait untuk menyediakan data, informasi, dan layanan yang benar dan akurat.",
  },
  {
    id: 4,
    title: "Apakah transaksi dan informasi pribadi saya aman?",
    description:
      "Di Efunding, kami mengutamakan keamanan transaksi dan informasi pribadi Anda. Kami menggunakan enkripsi tingkat tinggi sebagai standar industri untuk memastikan data Anda terlindungi. Kami secara rutin memperbarui sistem keamanan kami untuk memberikan perlindungan maksimal. Anda dapat bertransaksi dengan tenang.",
  },
];



// WEBPACK FOOTER //
// ./src/utils/efunding_faq.js